import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, vModelCheckbox as _vModelCheckbox } from "vue"

const _hoisted_1 = { class: "flex justify-between flex-nowrap" }
const _hoisted_2 = {
  ref: "shiftsContent",
  class: "w-537 h-screen flex flex-col justify-between flex-nowrap transition-all duration-300 ease-in-out transform-x"
}
const _hoisted_3 = { class: "pt-14 px-5 relative" }
const _hoisted_4 = { class: "px-2" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "ml-2 text-lightRed font-semibold text-xs leading-4" }, "Close the map", -1)
const _hoisted_6 = { class: "flex justify-between mb-7" }
const _hoisted_7 = { class: "flex justify-start" }
const _hoisted_8 = { class: "flex justify-between" }
const _hoisted_9 = { class: "relative h-42 w-288 me-3" }
const _hoisted_10 = { class: "w-full" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "h-full" }
const _hoisted_13 = { class: "flex justify-start items-center" }
const _hoisted_14 = { class: "me-2" }
const _hoisted_15 = {
  key: 0,
  class: "bg-white opacity-100 z-40",
  style: {"width":"12%"}
}
const _hoisted_16 = { class: "flex justify-start items-center" }
const _hoisted_17 = { class: "me-2" }
const _hoisted_18 = {
  key: 1,
  class: "bg-white opacity-100 z-40",
  style: {"width":"17%"}
}
const _hoisted_19 = { class: "flex justify-start items-center" }
const _hoisted_20 = { class: "me-2" }
const _hoisted_21 = {
  key: 2,
  class: "bg-white opacity-100 z-40",
  style: {"width":"12%"}
}
const _hoisted_22 = { class: "flex justify-start items-center" }
const _hoisted_23 = { class: "me-2" }
const _hoisted_24 = {
  key: 3,
  class: "bg-white opacity-100 z-40",
  style: {"width":"12%"}
}
const _hoisted_25 = { class: "flex justify-start items-center" }
const _hoisted_26 = { class: "me-2" }
const _hoisted_27 = {
  key: 4,
  class: "bg-white opacity-100 z-40",
  style: {"width":"15%"}
}
const _hoisted_28 = { class: "flex justify-start items-center" }
const _hoisted_29 = { class: "me-2" }
const _hoisted_30 = {
  key: 5,
  class: "bg-white opacity-100 z-40",
  style: {"width":"10%"}
}
const _hoisted_31 = {
  key: 6,
  class: "bg-white opacity-100 z-40",
  style: {"width":"8%"}
}
const _hoisted_32 = { key: 0 }
const _hoisted_33 = { class: "w-full tesx-xs font-normal text-darkText ms-2 leading-5" }
const _hoisted_34 = { class: "mb-1" }
const _hoisted_35 = { key: 0 }
const _hoisted_36 = { key: 1 }
const _hoisted_37 = { key: 2 }
const _hoisted_38 = { key: 3 }
const _hoisted_39 = { key: 4 }
const _hoisted_40 = { key: 5 }
const _hoisted_41 = { key: 6 }
const _hoisted_42 = { key: 7 }
const _hoisted_43 = ["disabled", "onClick"]
const _hoisted_44 = {
  key: 0,
  class: "text-center text-darkText text-lg px-4 mt-32 font-bold"
}
const _hoisted_45 = {
  ref: "shiftMap",
  class: "h-screen z-10 h-full calculated-width transition-all duration-300 ease-in-out"
}
const _hoisted_46 = { class: "p-8" }
const _hoisted_47 = { class: "form-group" }
const _hoisted_48 = {
  key: 0,
  class: "form-error"
}
const _hoisted_49 = { class: "form-group" }
const _hoisted_50 = {
  key: 0,
  class: "form-error"
}
const _hoisted_51 = { class: "flex flex-wrap items-center justify-end w-full" }
const _hoisted_52 = ["disabled"]
const _hoisted_53 = { class: "text-textColor font-bold text-md mb-" }
const _hoisted_54 = { class: "flex items-center gap-x-1 mt-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseIcon = _resolveComponent("BaseIcon")!
  const _component_PageTitle = _resolveComponent("PageTitle")!
  const _component_SearchInput = _resolveComponent("SearchInput")!
  const _component_FilterPanel = _resolveComponent("FilterPanel")!
  const _component_OrderByArrow = _resolveComponent("OrderByArrow")!
  const _component_DriverBalance = _resolveComponent("DriverBalance")!
  const _component_Popper = _resolveComponent("Popper")!
  const _component_UserWithAvatar = _resolveComponent("UserWithAvatar")!
  const _component_TableGhost = _resolveComponent("TableGhost")!
  const _component_Pagination = _resolveComponent("Pagination")!
  const _component_DriversMap = _resolveComponent("DriversMap")!
  const _component_InviteUser = _resolveComponent("InviteUser")!
  const _component_BaseModal = _resolveComponent("BaseModal")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_ConfirmationModal = _resolveComponent("ConfirmationModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_Transition, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              (_ctx.shortTable)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.startAnimation())),
                    class: "z-20 cursor-pointer absolute -right-18 top-110 ps-1 py-2 bg-white rounded-6 rounded transform -rotate-90"
                  }, [
                    _createElementVNode("div", _hoisted_4, [
                      _createVNode(_component_BaseIcon, {
                        style: {"width":"12px"},
                        name: "redarrow"
                      }),
                      _hoisted_5
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createVNode(_component_PageTitle, { title: "drivers.title" }),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createVNode(_component_SearchInput, {
                        modelValue: _ctx.searchValue,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchValue) = $event)),
                        placeholder: _ctx.$t('placeholders.driversSearch')
                      }, null, 8, ["modelValue", "placeholder"])
                    ]),
                    _createElementVNode("button", {
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showFilterModal = true)),
                      class: "border border-inputBorder w-42 h-42"
                    }, [
                      _createElementVNode("span", _hoisted_10, [
                        _createVNode(_component_BaseIcon, { name: "filter" })
                      ])
                    ]),
                    (_ctx.showFilterModal)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                          _createVNode(_component_FilterPanel, {
                            filters: _ctx.filters,
                            onClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showFilterModal = false)),
                            onFetchData: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onExpand($event)))
                          }, null, 8, ["filters"])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("button", {
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showModal = true)),
                    class: "primary flex items-center px-5 py-3"
                  }, [
                    _createVNode(_component_BaseIcon, {
                      name: "plus",
                      classNames: "text-xl me-1"
                    }),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('buttons.addDriver')), 1)
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", {
                style: _normalizeStyle({height: _ctx.height + 'px'}),
                class: "tableFixHead px-5"
              }, [
                _createElementVNode("table", null, [
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", {
                        class: "bg-white opacity-100 z-40",
                        style: _normalizeStyle(_ctx.shortTable ? 'width: 80%' : 'width: 22%')
                      }, [
                        _createElementVNode("div", _hoisted_13, [
                          _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.$t('table.driver')), 1)
                        ])
                      ], 4),
                      (!_ctx.shortTable)
                        ? (_openBlock(), _createElementBlock("th", _hoisted_15, [
                            _createElementVNode("div", _hoisted_16, [
                              _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.$t('table.mobile')), 1)
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (!_ctx.shortTable)
                        ? (_openBlock(), _createElementBlock("th", _hoisted_18, [
                            _createElementVNode("div", _hoisted_19, [
                              _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.$t('table.vehicle')), 1)
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (!_ctx.shortTable)
                        ? (_openBlock(), _createElementBlock("th", _hoisted_21, [
                            _createElementVNode("div", _hoisted_22, [
                              _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.$t('table.drivingLicense')), 1)
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (!_ctx.shortTable)
                        ? (_openBlock(), _createElementBlock("th", _hoisted_24, [
                            _createElementVNode("div", _hoisted_25, [
                              _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.$t('table.joiningDate')), 1),
                              _createVNode(_component_OrderByArrow, {
                                onSort: _cache[6] || (_cache[6] = ($event: any) => (_ctx.clickSort($event, 'created_at'))),
                                sortField: _ctx.sortFields[4]
                              }, null, 8, ["sortField"])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (!_ctx.shortTable)
                        ? (_openBlock(), _createElementBlock("th", _hoisted_27, [
                            _createElementVNode("div", _hoisted_28, [
                              _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.$t('table.shift')), 1)
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (!_ctx.shortTable)
                        ? (_openBlock(), _createElementBlock("th", _hoisted_30, _toDisplayString(_ctx.$t('table.assignShift')), 1))
                        : _createCommentVNode("", true),
                      (!_ctx.shortTable)
                        ? (_openBlock(), _createElementBlock("th", _hoisted_31, _toDisplayString(_ctx.$t('table.clockOutBtn')), 1))
                        : _createCommentVNode("", true),
                      _createElementVNode("th", {
                        class: "bg-white opacity-100 z-40",
                        style: _normalizeStyle(_ctx.shortTable ? 'width: 20%' : 'width: 10%')
                      }, _toDisplayString(_ctx.$t('table.location')), 5)
                    ])
                  ]),
                  (!_ctx.loading)
                    ? (_openBlock(), _createElementBlock("tbody", _hoisted_32, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.drivers, (driver) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            class: _normalizeClass(_ctx.selectedDriver.id === driver.id ? 'bg-moreBg' : null),
                            key: driver.id
                          }, [
                            _createElementVNode("td", null, [
                              _createVNode(_component_UserWithAvatar, {
                                onClick: ($event: any) => (_ctx.navigateToDetailed(driver.id)),
                                class: "cursor-pointer",
                                driverInfo: driver.driverInfo,
                                indicatorClass: driver.isClockIn ? driver.orderCount > 0 ? 'bg-warningColor' : 'bg-successColor' : null
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_33, [
                                    _createElementVNode("div", _hoisted_34, _toDisplayString(_ctx.createDriverFullName(driver.driverInfo)), 1),
                                    _createVNode(_component_Popper, {
                                      arrow: "",
                                      hover: "",
                                      placement: "auto"
                                    }, {
                                      content: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t('table.balance')), 1)
                                      ]),
                                      default: _withCtx(() => [
                                        _createVNode(_component_DriverBalance, {
                                          balance: driver.balance || 0
                                        }, null, 8, ["balance"])
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ])
                                ]),
                                _: 2
                              }, 1032, ["onClick", "driverInfo", "indicatorClass"])
                            ]),
                            (!_ctx.shortTable)
                              ? (_openBlock(), _createElementBlock("td", _hoisted_35, _toDisplayString(driver.driverInfo.userPhone), 1))
                              : _createCommentVNode("", true),
                            (driver.vehicleId && !_ctx.shortTable)
                              ? (_openBlock(), _createElementBlock("td", _hoisted_36, _toDisplayString(driver.vehicleId.model) + " " + _toDisplayString(driver.vehicleId.name), 1))
                              : _createCommentVNode("", true),
                            (!driver.vehicleId && !_ctx.shortTable)
                              ? (_openBlock(), _createElementBlock("td", _hoisted_37, "-"))
                              : _createCommentVNode("", true),
                            (!_ctx.shortTable)
                              ? (_openBlock(), _createElementBlock("td", _hoisted_38, _toDisplayString(driver.driverLicenseNo), 1))
                              : _createCommentVNode("", true),
                            (!_ctx.shortTable)
                              ? (_openBlock(), _createElementBlock("td", _hoisted_39, _toDisplayString(driver.createdAt), 1))
                              : _createCommentVNode("", true),
                            (!_ctx.shortTable)
                              ? (_openBlock(), _createElementBlock("td", _hoisted_40, _toDisplayString(driver.shift ? `${driver.shift.shiftStart} - ${driver.shift.shiftEnd}` : '-'), 1))
                              : _createCommentVNode("", true),
                            (!_ctx.shortTable)
                              ? (_openBlock(), _createElementBlock("td", _hoisted_41, [
                                  _createVNode(_component_BaseIcon, {
                                    class: "cursor-pointer",
                                    onClick: _withModifiers(($event: any) => (_ctx.openAssignShiftModal(driver)), ["stop"]),
                                    name: "edit"
                                  }, null, 8, ["onClick"])
                                ]))
                              : _createCommentVNode("", true),
                            (!_ctx.shortTable)
                              ? (_openBlock(), _createElementBlock("td", _hoisted_42, [
                                  _createElementVNode("button", {
                                    disabled: !driver.isClockIn,
                                    type: "button",
                                    onClick: _withModifiers(($event: any) => (_ctx.openClockOutModal(driver)), ["stop"]),
                                    class: "secondary w-24 m-1 px-4 py-2"
                                  }, _toDisplayString(_ctx.$t('buttons.clockOut')), 9, _hoisted_43)
                                ]))
                              : _createCommentVNode("", true),
                            _createElementVNode("td", null, [
                              _createVNode(_component_BaseIcon, {
                                class: "cursor-pointer",
                                onClick: _withModifiers(($event: any) => {_ctx.selectedDriver = driver; !_ctx.shortTable ? _ctx.startAnimation() : null}, ["stop"]),
                                name: "mappin"
                              }, null, 8, ["onClick"])
                            ])
                          ], 2))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.loading)
                    ? (_openBlock(), _createBlock(_component_TableGhost, {
                        key: 1,
                        "col-margin": "my-3",
                        row: 10,
                        col: _ctx.shortTable ? 2 : 9
                      }, null, 8, ["col"]))
                    : _createCommentVNode("", true)
                ]),
                (!_ctx.drivers.length && !_ctx.loading)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_44, _toDisplayString(_ctx.$t('validation.noItemsToShow')), 1))
                  : _createCommentVNode("", true)
              ], 4)
            ]),
            _createElementVNode("div", null, [
              (_ctx.pagination && _ctx.pagination.totalItems)
                ? (_openBlock(), _createBlock(_component_Pagination, {
                    key: 0,
                    current: _ctx.current,
                    total: _ctx.pagination.totalItems,
                    "page-range": 2,
                    basicPagination: _ctx.shortTable,
                    "per-page": _ctx.pagination.pageSize,
                    onPageChanged: _cache[7] || (_cache[7] = ($event: any) => (_ctx.current = $event)),
                    "text-before-input": "Go to page"
                  }, null, 8, ["current", "total", "basicPagination", "per-page"]))
                : _createCommentVNode("", true)
            ])
          ], 512),
          _withDirectives(_createElementVNode("div", _hoisted_45, [
            _createVNode(_component_DriversMap, {
              locations: _ctx.locations,
              selectedDriver: _ctx.selectedDriver
            }, null, 8, ["locations", "selectedDriver"])
          ], 512), [
            [_vShow, _ctx.shortTable]
          ])
        ])
      ]),
      _: 1
    }),
    (_ctx.showModal)
      ? (_openBlock(), _createBlock(_component_BaseModal, {
          key: 0,
          title: 'Add a driver',
          width: '488',
          onClose: _cache[9] || (_cache[9] = ($event: any) => (_ctx.showModal = $event))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_InviteUser, {
              onClose: _cache[8] || (_cache[8] = ($event: any) => (_ctx.showModal = false)),
              driversOnly: true
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.assignShiftModal)
      ? (_openBlock(), _createBlock(_component_BaseModal, {
          key: 1,
          loading: _ctx.loading,
          title: _ctx.$t('drivers.assignShift'),
          width: '488',
          onClose: _cache[14] || (_cache[14] = ($event: any) => (_ctx.assignShiftModal = $event))
        }, {
          default: _withCtx(() => [
            _createElementVNode("form", {
              onSubmit: _cache[13] || (_cache[13] = ($event: any) => (_ctx.assignShift($event))),
              class: "w-full"
            }, [
              _createElementVNode("div", _hoisted_46, [
                _createElementVNode("div", _hoisted_47, [
                  _createVNode(_component_Multiselect, {
                    canSelect: false,
                    modelValue: _ctx.darkstoreId,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.darkstoreId) = $event)),
                    options: _ctx.darkstores,
                    label: "value",
                    valueProp: "id",
                    noOptionsText: _ctx.$t('validation.noItemsToShow'),
                    placeholder: _ctx.$t('placeholders.darkstore')
                  }, null, 8, ["modelValue", "options", "noOptionsText", "placeholder"]),
                  (_ctx.v$.darkstoreId.$error)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_48, [
                        _createVNode(_component_BaseIcon, {
                          class: "me-1",
                          name: "alert"
                        }),
                        _createTextVNode(_toDisplayString(_ctx.$t('validation.required')), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_49, [
                  _createVNode(_component_Multiselect, {
                    canSelect: false,
                    modelValue: _ctx.shiftId,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.shiftId) = $event)),
                    options: _ctx.workShifts,
                    label: "value",
                    valueProp: "id",
                    noOptionsText: _ctx.$t('validation.noItemsToShow'),
                    placeholder: _ctx.$t('placeholders.workShift')
                  }, null, 8, ["modelValue", "options", "noOptionsText", "placeholder"]),
                  (_ctx.v$.shiftId.$error)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_50, [
                        _createVNode(_component_BaseIcon, {
                          class: "me-1",
                          name: "alert"
                        }),
                        _createTextVNode(_toDisplayString(_ctx.$t('validation.required')), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_51, [
                  _createElementVNode("button", {
                    onClick: _cache[12] || (_cache[12] = ($event: any) => {_ctx.assignShiftModal = false; _ctx.resetForm()}),
                    type: "button",
                    class: "secondary m-1 w-32 px-4 py-2"
                  }, _toDisplayString(_ctx.$t('buttons.close')), 1),
                  _createElementVNode("button", {
                    disabled: _ctx.v$.$invalid,
                    type: "submit",
                    class: "primary m-1 w-32 px-4 py-2"
                  }, _toDisplayString(_ctx.$t('buttons.assignShift')), 9, _hoisted_52)
                ])
              ])
            ], 32)
          ]),
          _: 1
        }, 8, ["loading", "title"]))
      : _createCommentVNode("", true),
    (_ctx.clockOutModal)
      ? (_openBlock(), _createBlock(_component_ConfirmationModal, {
          key: 2,
          header: _ctx.$t('drivers.clockOutTitle'),
          hasIcon: false,
          title: _ctx.$t('drivers.clockOutMessage'),
          cancelText: _ctx.$t('buttons.reject'),
          confirmText: _ctx.$t('buttons.approve'),
          onConfirm: _cache[17] || (_cache[17] = ($event: any) => (_ctx.approveClockout(1))),
          onCancel: _cache[18] || (_cache[18] = ($event: any) => (_ctx.approveClockout(0)))
        }, {
          default: _withCtx(() => [
            _createElementVNode("p", _hoisted_53, _toDisplayString(_ctx.$t('drivers.clockOutMessage')), 1),
            _createElementVNode("div", _hoisted_54, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.isManual) = $event))
              }, null, 512), [
                [_vModelCheckbox, _ctx.isManual]
              ]),
              _createElementVNode("span", {
                role: "button",
                class: "text-black font-bold",
                onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.isManual = !_ctx.isManual))
              }, _toDisplayString(_ctx.$t('drivers.clockOutUnAssignOrderMessage')), 1)
            ])
          ]),
          _: 1
        }, 8, ["header", "title", "cancelText", "confirmText"]))
      : _createCommentVNode("", true)
  ], 64))
}